import React, { useEffect, useRef, useState } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { ActivityIndicator, ScrollView, TouchableOpacity, View, FlatList } from 'react-native';
import Colors from '../../constants/Colorsv2';
import { FilterType } from '../../store/actions/analyticActions';
import { AnalyticBarChart, AnalyticPieChart } from './AnalyticComponents/AnalyticCharts';
import FilterCard from './AnalyticComponents/FilterCard';
import AnalyticChartCard from './AnalyticComponents/AnalyticChartCard';
import { MetricsComponent } from '../../objectTypes';
import MetricCard from './AnalyticComponents/MetricCard';
import { Text } from '../../globalComponents/NativeOverrides';
import Styles from '../../constants/Styles';
import moment from 'moment';
import AnalyticPositionCard from './AnalyticComponents/AnalyticPositionCard';
import ActivityActionModal from '../../screensV1/Social/components/ActivityActionModal';
import { analytics_getMetricsByFilter } from '../../store/actionsv1/analytics';
import { market_bulkGetOrders } from '../../store/actionsv1/markets';
import { OrderProps } from '../../store/types/mk_svc';
import OrderCard from '../../Componentsv1/OrderCard';
import { PremiumAnalytics } from '../../Componentsv1/Icons';
import { player_getHelpPromptById } from '../../store/actionsv1/player';

const actions = [{type:'share', label:'See Position Details', color:Colors.brand.midnight}, {type:'activity', label: 'See Trade Activity', color:Colors.brand.midnight}]
const ActivityMetricsScreen = ({ navigation, metrics_data, filter, market_type, order_ids, player }) => {
    const [ isActionVisible, setIsActionVisible ] = useState(false)
    const [ detailed_offset, setDetailedOffset ] = useState([{
        offset: 0,
        order_ids: []
    }]);
    const [ active_offset, setActiveOffset ] = useState(999);
    const [ screenWidth, setScreenWidth ] = useState(400)
    const [ filterHeight, setFilterHeight ] = useState(70)
    const [ activeTab, setActiveTab ] = useState('visual')
    const [ filterVisible, setFilterVisible ] = useState(true)
    const [ loading, setLoading ] = useState(false)
    const [ selectedPosition, setSelectedPosition ] = useState<any | undefined>()
    const [ uniqueDates, setUniqueDates ] = useState<string[]>([])
    const [ activeDate, setActiveDate ] = useState<string|undefined>()
    const dateScrollRef = useRef()

    let viewable_metrics = metrics_data
    if(player?.type != 'premium'){
        viewable_metrics = metrics_data.filter(m => m.type == 'metric')
    }

    const orders:OrderProps[] = useSelector((state:any) => state.social.viewing_orders.filter((o:OrderProps) => order_ids.includes(o.order_id.toString())), (left, right) => left.length == right.length)
    const filtered_orders = orders.filter(o => moment(o.last_update_datetime).format('YYYY-MM-DD') == activeDate)

    const dispatch = useDispatch();

    useEffect(() => {
        getMetricsFromServer(filter)
    },[])

    useEffect(() => {
        let iterations = Math.round(order_ids.length / 50)
        if(iterations == 0){
            setActiveOffset(0)
            return setDetailedOffset([{ offset:0, order_ids }])
        }
        let offsets:any[] = []
        for (let i = 0; i < iterations; i++) {
            let start = i * 50
            const offset_order_ids = order_ids.slice(start, start + 50);
            offsets.push({ offset: i, order_ids: offset_order_ids })
        }

        setDetailedOffset(offsets)
        setActiveOffset(0)
    },[order_ids.length])


    useEffect(() => {
        if(activeTab !== 'detailed'){ return }
        console.log(active_offset)
        getOrdersFromServer(active_offset)
    },[active_offset, detailed_offset[0]?.order_ids.length])


    useEffect(() => {
        if(orders.length === 0){ return }
        console.log('Order length was different!!!!')
        const dates = [ ...new Set(orders.sort((a,b) => moment(a.last_update_datetime).unix() - moment(b.last_update_datetime).unix()).map(o => moment(o.last_update_datetime).format('YYYY-MM-DD'))) ]
        setUniqueDates(dates)
        setActiveDate(dates[0])
    },[orders.length])

    useEffect(() => {
        if(activeTab === 'detailed' && dateScrollRef?.current){
            dateScrollRef.current.scrollToEnd({ animated: true });
            getOrdersFromServer(active_offset)
        }
    },[activeTab])


    const getOrdersFromServer = async(offset:number) => {
        let ids = detailed_offset.find(o => o.offset == offset)?.order_ids
        if(!ids || ids.length === 0){ return }
        console.log('getting orders from server!!!')
        await dispatch(market_bulkGetOrders(ids))
        //setDetailedOffset(detailed_offset + 1)
    }

    const handleSeeMore = () => {
        let offset = detailed_offset[active_offset + 1]
        if(!offset){ return }
        setActiveOffset(active_offset + 1)
    }

    const getMetricsFromServer = async(filter:FilterType) => {
        setLoading(true)
        await dispatch(analytics_getMetricsByFilter({ ...filter, data_level:'markets', market_type }))
        setTimeout(() => {
            setLoading(false)
        }, 1000); 
    }
    const renderMetrics = (data: { item:MetricsComponent, index:number }) => {
        switch(data.item.type){
            case 'chart': 
                return (
                    <View key={data.item.metric_id} style={{ width:screenWidth }}>
                        <AnalyticChartCard metric={data.item} width={screenWidth}/>
                    </View>
                )
            case 'metric': 
                return (
                    <View key={data.item.metric_id} style={{ margin:10, marginBottom:0, backgroundColor:Colors.shades.shade100, borderRadius:8, padding:0, minWidth:150, width:data.item.full_width?screenWidth-20:(screenWidth * 0.5)-20 }}>
                        <MetricCard metric={data.item} market_type={market_type} show_filter={false} />
                    </View>
                )
            default: return (<></>)
        }
    }

    const handleAction = (type:string) => {
        setIsActionVisible(false)
        if(!selectedPosition){ return }
        switch(type){
            case 'activity': return navigation.navigate('EventStack', { screen: 'TradeActivity', initial: false, params: { order_id: selectedPosition.order_id, be_type:selectedPosition.be_type } })
            case 'share': return navigation.navigate('EventStack', { screen: 'ShareablePosition', initial:false, params: { position_id: selectedPosition.position_id, be_type: selectedPosition.be_type } })
        }
    }
    const renderDates = (data: {item: string, index:number}) => {
        const active = data.item === activeDate ? true : false
        let last = data.item == uniqueDates[uniqueDates.length -1] && detailed_offset.length -1 != active_offset && orders.length < order_ids.length ? true : false

        return (
            <View style={{ flexDirection:'row' }}>
                <TouchableOpacity style={{ padding:5, justifyContent:'center', alignItems:'center', paddingLeft:10, paddingRight:10, borderBottomWidth:1, borderBottomColor:active?Colors.brand.midnight:'transparent' }} onPress={() => setActiveDate(data.item)}>
                    <Text size={14} color={active?Colors.brand.midnight:Colors.brand.slate} weight={active?'semibold':'light'}>{moment(data.item).format('ddd')}</Text>
                    <Text size={14} color={active?Colors.brand.midnight:Colors.brand.slate} weight={active?'semibold':'light'}>{moment(data.item).format('MMM D')}</Text>
                </TouchableOpacity>
                {last ? 
                <TouchableOpacity style={{padding:5, justifyContent:'center', alignItems:'center', paddingLeft:10, paddingRight:10, borderBottomWidth:1, borderBottomColor:'transparent'}} onPress={() => handleSeeMore()}>
                    <Text size={14} color={Colors.brand.electric} weight={'light'}>SEE</Text>
                    <Text size={14} color={Colors.brand.electric} weight={'light'}>MORE</Text>
                </TouchableOpacity>
                :<></>}
            </View>
            
        )
    }
    const renderOrders = (data: { item:OrderProps, index:number }) => {
        return (
            <View style={{ margin:5 }}>
                <OrderCard navigation={navigation} prevent_event_load order={data.item} view_mode={'edit'}/>
            </View>
        )
    }
    const handleScrollEvent = (ev:any) => {
        const contentOffset = ev.nativeEvent.contentOffset.y
        if(contentOffset > 5){ setFilterVisible(false); setFilterHeight(0); return; }
        return setFilterVisible(true) 
    }

    return (
        <View style={{ flex:1, backgroundColor:Colors.shades.white }}>
            <ScrollView scrollEventThrottle={10} onScroll={(ev) => handleScrollEvent(ev)} style={{ flex:1, marginTop:filterHeight+10 }}>
                <View style={{padding:10, paddingBottom:0}}>
                    <View style={Styles.viewStyles.toggleBox}>
                        <TouchableOpacity style={[activeTab==='visual'?Styles.viewStyles.activeToggle:Styles.viewStyles.inactiveToggle, { flex:1 }]} onPress={() => setActiveTab('visual')}>
                            <Text style={activeTab==='visual'?Styles.textStyles.activeToggleText:Styles.textStyles.inactiveToggleText}>Visual</Text>
                        </TouchableOpacity>
                        <TouchableOpacity style={[activeTab==='detailed'?Styles.viewStyles.activeToggle:Styles.viewStyles.inactiveToggle, { flex:1 }]} onPress={() => setActiveTab('detailed')}>
                            <Text style={activeTab==='detailed'?Styles.textStyles.activeToggleText:Styles.textStyles.inactiveToggleText}>Detailed</Text>
                        </TouchableOpacity>
                    </View>
                </View>
                {loading ?
                <View style={{padding:10, justifyContent:'center', alignItems:'center'}}>
                    <ActivityIndicator size='large' color={Colors.brand.midnight} />
                </View>
                :
                <View onLayout={(ev) => {
                    const { width } = ev.nativeEvent.layout;
                    setScreenWidth(width)
                }} >
                    {activeTab === 'visual' ?
                    <View style={{ justifyContent:'center', alignItems:'center' }} >
                        <View style={{flexDirection:'row', flexWrap:'wrap', justifyContent:'center', alignItems:'center'}} >
                            {viewable_metrics.map((d, i) => {
                                return renderMetrics({item:d, index:i})
                            })}
                        </View>
                        {player?.type != 'premium' ?
                        <View style={{ padding:20, justifyContent:'center', alignItems:'center' }}>
                            <Text style={{ marginBottom:10 }} size={20} color={Colors.brand.midnight} weight='bold' textAlign='center'>Want even more insights?</Text>
                            <PremiumAnalytics size={80} color={Colors.incentive.gold} />
                            <TouchableOpacity style={{  marginTop:20, backgroundColor:Colors.incentive.gold, padding:15, borderRadius:8 }} onPress={() => dispatch(player_getHelpPromptById('t2_insights_1'))}>
                                <Text size={16} color={Colors.shades.white} weight='bold' textAlign='center'>Unlock With Premium!</Text>
                            </TouchableOpacity>
                        </View>
                        :<></>}
                    </View>
                    : activeTab === 'detailed' ?
                    <View style={{ marginTop:10, flex:1 }}>
                        <View style={{ marginTop:5, marginBottom:10 }}>
                            <FlatList ref={dateScrollRef} data={uniqueDates} renderItem={renderDates} keyExtractor={(item) => item} horizontal showsHorizontalScrollIndicator={false}/>
                        </View>
                        <FlatList data={filtered_orders} renderItem={renderOrders} keyExtractor={(item) => item.order_id.toString()}/>
                    </View>
                    :<></>}
                </View>
                }
                
            </ScrollView>
            {filterVisible ?
            <FilterCard filter={filter} loading={loading} onChange={(filter:FilterType) => getMetricsFromServer(filter)} onHeightChange={(height:number) => setFilterHeight(height)}/>
            :<></>}
            <ActivityActionModal actions={actions} isVisible={isActionVisible} actionTaken={handleAction} closeModal={() => setIsActionVisible(false)}/>
        </View>
    )
}

const mapStateToProps = (state:any) => {
    return {
        metrics_data:state.analytics.metrics.markets,
        market_type: state.auth.market_type,
        order_ids: state.analytics.order_ids,
        filter: state.analytics.filter,
        player: state.player.player
    }
}

const mapDispatchToProps = (dispatch:any) => {
    return {
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ActivityMetricsScreen)